// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"c0be730e","481":"ec2ce73f","995":"82fb3149"}[chunkId] + ".chunk.css";
};